import React from 'react';
import styled from 'styled-components';
import Location from '../../assets/target.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';


const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:50vh;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

  
`;

const Coverbg = styled.img`
  position: absolute;
  max-height: 100%;
  min-width: 100%;
  object-fit: cover;
  align-self:center; 
  border: none;
`;

class CardJuvenile extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
    
      <Coverbg src= {'https://i0.wp.com/mexican-fish.com/wp-content/uploads/F202-Opaleye-5.jpg?resize=570%2C381&ssl=1'}/>      
      
    
      
            
    </Viz>

      <ReusableDetailCard
   trend= {Location}
   metricsm="Reefs and Estuaries"
   diagnosis="Many of the world’s marine fish spend their first days or weeks feeding and developing at the ocean surface. The phytoplankton these fish feed on are now comingled with small, indigestible bits of plastic, which in effect starve many developing larvae."
   prediction="Larval and juvenile fish are the next generation of adult fish that will supply protein and essential nutrients to people around the world. Depleted fish stocks will have far reaching economic and ecological consequnences (NOAA)."
   significanceorthreat="SIGNIFICANCE"
   confidence="CONFICENCE LV: 95%"
   />
  </Container>
  );
 }
}

export default CardJuvenile;
